import { Injectable } from '@angular/core';
import { BaseService } from '../core';
import { Wallet } from '../dto';
import { TRANSACTION_TYPE, USED_TYPE } from '../shared';

@Injectable({
  providedIn: 'root',
})
export class WalletService extends BaseService {
  POINT_HISTORY_TYPE = {
    [TRANSACTION_TYPE.PURCHASE_ORDER]: USED_TYPE.USED,
    [TRANSACTION_TYPE.POINT_OUT]: USED_TYPE.REMOVED,
    [TRANSACTION_TYPE.PURCHASE_CANCEL]: USED_TYPE.ADDED,
    [TRANSACTION_TYPE.POINT_IN]: USED_TYPE.ADDED,
    [TRANSACTION_TYPE.POINT_EXPIRED]: USED_TYPE.REMOVED,
  };

  CREDIT_HISTORY_TYPE = {
    [TRANSACTION_TYPE.PURCHASE_ORDER]: USED_TYPE.USED,
    [TRANSACTION_TYPE.CREDIT_OUT]: USED_TYPE.REMOVED,
    [TRANSACTION_TYPE.PURCHASE_CANCEL]: USED_TYPE.ADDED,
    [TRANSACTION_TYPE.CREDIT_IN]: USED_TYPE.ADDED,
  };

  getWalletBalance() {
    return super.get<Wallet>('/wallet/balance');
  }

  isAlreadyShowPointInfo() {
    if (!localStorage.getItem('pointInfo')) {
      localStorage.setItem('pointInfo', 'has');
      return false;
    }
    return true;
  }
}
